import { PContentWrapper } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import styles from './contentsection.module.css'

type Props = React.PropsWithChildren<{
  imageSrc?: string
  imageAlt?: string
  className?: string
}>

const ContentSection = ({ children, imageSrc, imageAlt, className }: Props) => {
  return (
    <PContentWrapper width='fluid'>
      <div className={clsx(className, styles.section)}>
        <PContentWrapper width='fluid'>
          {imageSrc && (
            <div className={styles.imageWrapper}>
              <img alt={imageAlt} src={imageSrc} className={styles.image} />
            </div>
          )}
          {children}
        </PContentWrapper>
      </div>
    </PContentWrapper>
  )
}

export default ContentSection
